import React from 'react';
import {Formik, Form, Field } from 'formik';
import { FormControl, Stack } from '@chakra-ui/react';
import { ThemedStyledInput } from '../../../../../components/Styled';
import * as Yup from 'yup';
import { CustomButton } from "../../../../../components/Styled/StyledButtons";
import { Icon } from "@iconify/react";
import FieldErrorMessage from "../../../../../components/FieldErrorMessage/FieldErrorMessage";

const validationSchema = Yup.object({
    name: Yup.string()
        .max(30, 'Search & Filters Error: Name Must be 30 characters or less')
        .trim('Search & Filters Error: Name cannot be just whitespace')
        .strict(true)
});

const PublicationCategorySearchFilter = ({ onFilterChange }) => {
    return (
        <Formik
            initialValues={{ name: '' }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting, resetForm }) => {
                if (!values.name) {
                    onFilterChange({ name: '' });
                } else {
                    onFilterChange(values);
                }
                setSubmitting(false);
            }}
            onReset={() => {
                onFilterChange({ name: '' });
            }}
        >
            {({ values, resetForm, handleSubmit }) => (
                <Form>
                    <Stack spacing={2} direction="row" align="center">
                        <FormControl>
                            <Field
                                as={ThemedStyledInput}
                                id="name"
                                name="name"
                                type="text"
                                placeholder="Search by Publication Category Name"
                            />
                        </FormControl>
                        <CustomButton
                            onClick={handleSubmit}
                            type="search"
                            tooltipLabel="Search"
                            icon={<Icon icon="bi:search" />}
                            showLabel={false}
                        >
                            Search
                        </CustomButton>
                        <CustomButton
                            type="reset"
                            onClick={() => {
                                resetForm();
                                onFilterChange({ name: '' });
                            }}
                            tooltipLabel="Clear Filters"
                            icon={<Icon icon="radix-icons:reset" />}
                            showLabel={false}
                        >
                            Clear
                        </CustomButton>
                    </Stack>
                    <FieldErrorMessage name="name" />

                </Form>
            )}
        </Formik>
    );
};

export default PublicationCategorySearchFilter;
